module.exports = __webpack_public_path__ + "img/inavailable_channel.2faf552d.png";